// Lightweight driver identity stored locally. No signup, no server round-trip.
// Used before a user's first drop or claim so other drivers can identify them
// during a handover.
const KEY = "spotdrop_driver_profile";

const MAX = { nickname: 30, car_color: 30, car_model: 40, full_plate: 12 };

export function getProfile() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || typeof p !== "object") return null;
    return p;
  } catch {
    return null;
  }
}

export function saveProfile(p) {
  const clean = sanitize(p);
  const err = validate(clean);
  if (err) throw new Error(err);
  localStorage.setItem(KEY, JSON.stringify(clean));
  return clean;
}

export function clearProfile() {
  localStorage.removeItem(KEY);
}

export function isProfileComplete(p = getProfile()) {
  return !validate(p);
}

function trimTo(s, n) {
  return String(s || "").trim().slice(0, n);
}

export function sanitize(p) {
  if (!p) return {};
  return {
    nickname: trimTo(p.nickname, MAX.nickname),
    car_color: trimTo(p.car_color, MAX.car_color),
    car_model: trimTo(p.car_model, MAX.car_model),
    plate_last3: String(p.plate_last3 || "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 3),
    full_plate: trimTo(p.full_plate, MAX.full_plate).toUpperCase(),
  };
}

/** Returns an error message string if invalid, otherwise null. */
export function validate(p) {
  if (!p) return "Please fill in your driver details.";
  if (!p.nickname || p.nickname.length < 2) return "Please enter your nickname (min 2 characters).";
  if (!p.car_color || p.car_color.length < 2) return "Please enter your car color.";
  if (!p.car_model || p.car_model.length < 2) return "Please enter your car model.";
  if (!p.plate_last3 || p.plate_last3.length !== 3) return "Please enter the last 3 characters of your plate.";
  if (p.full_plate && p.full_plate.length < 4) return "Full plate seems too short — leave blank or enter the complete plate.";
  return null;
}
